import React from "react";
import { createRoot } from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import SGGApp from "./SGGApp";
import ErrorBoundary from "./ErrorBoundary";
import "./i18n";
// import notificationManager from './notification/NotificationManager';

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <SGGApp />
      </ErrorBoundary>
    </React.StrictMode>,
  );
}
serviceWorkerRegistration.register();
// notificationManager.requestPermission();
